import React, { useState, useEffect } from 'react'
import NumberInput from '../../../elements/NumberInput/NumberInput'
import { checkForEmpty, checkOnlyDot, checkRegEx } from '../../helpers/checkers'
import floorFigure from '../../helpers/floorFigure'
import { regexes } from '../../helpers/regex'

export default function MultiplierInput({ handleMultiplier, value }: any) {
  const [multiplierValue, setMultiplierValue] = useState('')

  const handleChange = (e: any) => {
    const value = e.target.value
    if (checkRegEx(value, regexes.numbersAndTwoDecimalsAfterDot)) {
      setMultiplierValue(value)
    }
  }
  const handleBlur = (s: any) => {
    const value = s.target.value
    if (checkForEmpty(value) || checkOnlyDot(value)) {
      return handleMultiplier('0.00'), setMultiplierValue('0.00')
    }
    handleMultiplier(value)
    // setMultiplierValue(floorFigure(value, 2))
    setMultiplierValue((+value).toFixed(2))
  }

  useEffect(() => {
    // setMultiplierValue(floorFigure(value, 2))
    setMultiplierValue((+value).toFixed(2))
  }, [value])

  return (
    <NumberInput
      value={multiplierValue}
      handleBlur={handleBlur}
      handleChange={handleChange}
      title='MULTIPLIER'
      placeholder='0.00'
      readOnly
    />
  )
}
